import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Faq from './pages/Faq';
import Pricing from './pages/Pricing';
import Schedule from './pages/Schedule';
import Safety from './pages/Safety';
import FloorScraperRental from './pages/FloorScraperRental';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ProposalView from './pages/ProposalView';
import InvoiceView from './pages/InvoiceView';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import BookingsList from './pages/admin/BookingsList';
import BookingDetail from './pages/admin/BookingDetail';
import InventoryList from './pages/admin/InventoryList';
import BlockDates from './pages/admin/BlockDates';
import AbandonedIntents from './pages/admin/AbandonedIntents';
import HeatmapAdmin from './pages/admin/Heatmap';
import CustomersList from './pages/admin/CustomersList';
import CustomerDetail from './pages/admin/CustomerDetail';
import InquiriesList from './pages/admin/InquiriesList';
import InquiryDetail from './pages/admin/InquiryDetail';
import ProposalBuilder from './pages/admin/ProposalBuilder';
import InvoiceBuilder from './pages/admin/InvoiceBuilder';
import SalesDashboard from './pages/admin/SalesDashboard';
import Expenses from './pages/admin/Expenses';
import SalesReports from './pages/admin/SalesReports';
import EmailTemplates from './pages/admin/EmailTemplates';
import ProtectedRoute from './components/ProtectedRoute';
import { Routes, Route } from 'react-router-dom';

function App() {
     return (
          <Routes>
               <Route path='/' element={<Home />} />
               <Route path='/about-us' element={<AboutUs />} />
               <Route path='/faq' element={<Faq />} />
               <Route path='/pricing' element={<Pricing />} />
               <Route path='/schedule' element={<Schedule />} />
               <Route path='/safety' element={<Safety />} />
               <Route path='/privacy' element={<PrivacyPolicy />} />
               <Route path='/floor-scraper-rental' element={<FloorScraperRental />} />
               <Route path='/proposal/:token' element={<ProposalView />} />
               <Route path='/invoice/:token' element={<InvoiceView />} />

               {/* Admin Routes */}
               <Route path='/admin/login' element={<AdminLogin />} />
               <Route
                    path='/admin'
                    element={
                         <ProtectedRoute>
                              <AdminLayout />
                         </ProtectedRoute>
                    }
               >
                    <Route index element={<Dashboard />} />
                    <Route path='bookings' element={<BookingsList />} />
                    <Route path='bookings/:id' element={<BookingDetail />} />
                    <Route path='inventory' element={<InventoryList />} />
                    <Route path='calendar' element={<BlockDates />} />
                    <Route path='abandoned' element={<AbandonedIntents />} />
                    <Route path='heatmap' element={<HeatmapAdmin />} />
                    <Route path='customers' element={<CustomersList />} />
                    <Route path='customers/:id' element={<CustomerDetail />} />
                    <Route path='inquiries' element={<InquiriesList />} />
                    <Route path='inquiries/:id' element={<InquiryDetail />} />
                    <Route path='inquiries/:inquiryId/proposal/new' element={<ProposalBuilder />} />
                    <Route path='proposals/:id/edit' element={<ProposalBuilder />} />
                    <Route path='inquiries/:inquiryId/invoice/new' element={<InvoiceBuilder />} />
                    <Route path='invoices/:id/edit' element={<InvoiceBuilder />} />
                    <Route path='sales' element={<SalesDashboard />} />
                    <Route path='expenses' element={<Expenses />} />
                    <Route path='reports' element={<SalesReports />} />
                    <Route path='email-templates' element={<EmailTemplates />} />
               </Route>
          </Routes>
     );
}

export default App;
